import YouTube from 'react-youtube';

import { Box, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { AI_MARKETER_ANALYTICS_EVENT, COPY, YOUTUBE_VIDEO_ID } from '~/features/ai-marketer/constants';
import { trackEvent } from '~/features/analytics/track-event';

export function AiMarketerVideoSection() {
  return (
    <Box as='section' bg='grey.50' pb={{ base: 0, md: '120px' }} pt={{ base: '56px', md: '96px' }}>
      <ContentContainer contentMaxWidth='content-max-width-md' mobilePadding='0' textAlign='center'>
        <Heading
          as='h2'
          color='grey.900'
          letterSpacing='-0.02em'
          maxWidth='712px'
          mb='48px'
          mx='auto'
          px={{ base: 4, md: 0 }}
          size={{ base: 'mobile-heading-2', md: 'heading-2' }}
        >
          {COPY.video.title}
        </Heading>
        <Box
          bg='#0A0B0F'
          borderRadius={{ base: 0, md: '12px' }}
          margin='0 auto'
          maxWidth='1056px'
          overflow='hidden'
          position='relative'
        >
          <YouTube
            iframeClassName='youtube-container'
            title={COPY.video.title}
            videoId={YOUTUBE_VIDEO_ID}
            opts={{
              host: 'https://www.youtube-nocookie.com',
              playerVars: {
                rel: 0,
              },
              width: '100%',
              height: '100%',
            }}
            style={{
              aspectRatio: 16 / 9,
            }}
            onPlay={() =>
              trackEvent({
                type: 'click',
                name: AI_MARKETER_ANALYTICS_EVENT,
                label: 'play_video',
              })
            }
          />
        </Box>
      </ContentContainer>
    </Box>
  );
}
